<div class="login-screen">
  <div class="panel p-4">
    <div class="panel-header">
      <div class="d-flex justify-content-center mb-3">
        <img class="w-100px h-100px" src="assets/img/logo.webp" alt="FPV" />
      </div>
      <h1 class="text-center">Fondo de Protección Vehicular</h1>
      <p class="text-center">Ingresa con el correo con el que estás registrado.</p>
    </div>

    <div class="panel-body">
    <button type="button" class="login-btn" (click)="microsoft.emit()">
      <svg viewBox="0 0 21 21" aria-hidden="true">
        <rect x="1" y="1" width="9" height="9" fill="#f25022" />
        <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
        <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
        <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
      </svg>
      Continuar con Microsoft
    </button>
@if(false){
    <button type="button" class="login-btn hidden" disabled>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path fill="#4285F4" d="M23.5 12.3c0-.8-.1-1.6-.2-2.3H12v4.4h6.5a5.6 5.6 0 0 1-2.4 3.7v3h3.9c2.3-2.1 3.5-5.2 3.5-8.8z" />
        <path fill="#34A853" d="M12 24c3.2 0 5.9-1.1 7.9-2.9l-3.9-3c-1.1.7-2.4 1.2-4 1.2-3.1 0-5.7-2.1-6.6-4.9H1.4v3.1A12 12 0 0 0 12 24z" />
        <path fill="#FBBC05" d="M5.4 14.4A7.2 7.2 0 0 1 5 12c0-.8.1-1.6.4-2.4V6.5H1.4A12 12 0 0 0 0 12c0 1.9.5 3.8 1.4 5.5l4-3.1z" />
        <path fill="#EA4335" d="M12 4.8c1.7 0 3.3.6 4.5 1.8l3.4-3.4A12 12 0 0 0 1.4 6.5l4 3.1C6.3 6.8 8.9 4.8 12 4.8z" />
      </svg>
      Continuar con Google
      <span>Próximamente</span>
    </button>
}
    </div>
  </div>
</div>
